import { Link } from 'react-router-dom';

import { PageContainer } from '@/components/layout/PageContainer/PageContainer';

import styles from '@/styles/layout.module.css';

export function AppFooter(): JSX.Element {
  return (
    <footer className={styles.footer}>
      <PageContainer className={styles.footerInner}>
        <nav className={styles.footerLinks} aria-label="Links institucionais">
          <Link className={styles.footerLink} to="/termos">
            Termos de uso
          </Link>
          <Link className={styles.footerLink} to="/privacidade">
            Política de privacidade
          </Link>
        </nav>

        <p className={styles.footerCredit}>
          Site desenvolvido por{' '}
          <a className={styles.footerCreditLink} href="https://dikaiosun.com.br/" target="_blank" rel="noreferrer noopener">
            Dikaiosun
          </a>
        </p>
      </PageContainer>
    </footer>
  );
}
